import { createStore, combineReducers } from 'redux';

export default function configureStore() {
  return createStore(combineReducers({}), {});
}
